import {useContext, createContext} from "react";

const UserContext = createContext();

export const useUser = _ => useContext(UserContext)

export default UserContext;